import { useEffect } from "react";
import { useVisitorId } from "hooks/useVisitor";
import { sendSessionData } from "utils/functions/sendSessionData";
import { getSessionData } from "utils/functions/getSessionData";

const visitTime = new Date().toLocaleString();

const ClientSession = () => {
  const visitorId = useVisitorId();

  const skipIfZeroKeys = [
    "screen_width",
    "screen_height",
    "screen_res_w",
    "screen_res_h",
  ];

  const setClarityTag = (key, value) => {
    const skipZero = skipIfZeroKeys.includes(key) && value === 0;
    const isValid = value !== undefined && value !== null && !skipZero;

    if (
      isValid &&
      typeof window !== "undefined" &&
      typeof window.clarity === "function"
    ) {
      window.clarity("set", key, value);
    }
  };

  useEffect(() => {
    if (!visitorId) return;

    (async () => {
      const sessionData = await getSessionData(visitorId);
      await sendSessionData(visitorId);

      try {
        setClarityTag("visitor_id", visitorId);
        setClarityTag("ip_address", sessionData.ipData?.ip);
        setClarityTag("time", visitTime);
        setClarityTag("time_zone", sessionData.timeZone);
        setClarityTag("latitude", sessionData.locationData?.latitude);
        setClarityTag("longitude", sessionData.locationData?.longitude);
        setClarityTag("city", sessionData.locationData?.city);
        setClarityTag("region", sessionData.locationData?.region);
        setClarityTag("width", `${sessionData.screenResolution?.width}`);
        setClarityTag("height", `${sessionData.screenResolution?.height}`);
        setClarityTag(
          "color_depth",
          `${sessionData.screenResolution?.colorDepth}`
        );
      } catch (err) {
        console.warn("Clarity tag error:", err);
      }
    })();
  }, [visitorId]);

  return null;
};

export default ClientSession;
